<tfoot *ngIf="lista&&lista.length === 0  || lista ===null">
  <tr class="odd">
    <td valign="top" colspan="4" class="text-center"><b>
        <i class="fa fa-search fa-1x"></i>
        Nenhum registro localizado!</b></td>
  </tr>
</tfoot>